import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { IFarmLandsState } from "../shared/interfaces/farm-lands-state";
import { FarmLand } from "../shared/models/farm-land";
import { farmLandsService } from "../shared/services/farm-lands.service";

const initialState: IFarmLandsState = {
  item: null,
  isLoading: false,
  list: [],
  listCount: 0,
};
export const FIELDS_MODULE_NAME = "farmLands";
export const farmLandsSlice = createSlice({
  name: FIELDS_MODULE_NAME,
  initialState,
  reducers: {
    setListAction(state, action: PayloadAction<FarmLand[]>): void {
      state.list = action.payload;
    },
    setListCountAction(state, action: PayloadAction<number>): void {
      state.listCount = action.payload;
    },
    setDetailsAction(state, action: PayloadAction<FarmLand | null>): void {
      state.item = action.payload;
    },
    clearDetailsAction(state): void {
      state.item = null;
    },
  },
});

export const farmLandsReducer = farmLandsSlice.reducer;
export const { setListAction, setDetailsAction, clearDetailsAction, setListCountAction } =
  farmLandsSlice.actions;

export const fetchFarmLandByIdAction = createAsyncThunk<void, string>(
  `${FIELDS_MODULE_NAME}/fetchFarmLandById`,
  async (id, { dispatch }) => {
    if (id === null) {
      return;
    }

    const dto = await farmLandsService.get(id);
    const model = new FarmLand();
    model.updateFromDto(dto);
    dispatch(setDetailsAction(model));
  }
);

export const fetchFarmLandIdByArcGisIdAction = createAsyncThunk<string | null, string>(
  `${FIELDS_MODULE_NAME}/fetchFarmLandByArcGisId`,
  async (id) => {
    if (id === null) {
      return null;
    }

    const dto = await farmLandsService.getByArcGisId(id);
    return dto ? dto.id : null;
  }
);
